<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://")
        .fields__element
            label.fields__label.fields__label--small {{ $i18n.t('dashboard.dashboard_sidebar_courses') }}
            cs-multiselect.fields__input(
                :multiple="false",
                :options="courses",
                :show-labels="false",
                :allow-empty="true",
                :custom-label="getCoursesName",
                :hideSelected="true",
                :placeholder="$i18n.t('fields.fields_anyStatus')",
                v-model="form.course",
                :searchable="false"
            )
</template>

<script>
/*eslint-disable*/
import _ from 'lodash';
import searchParamsStore from '../utils/searchParamsStore'
import { mapState } from 'vuex';
import moment from 'moment'

export default {
    mixins: [searchParamsStore],
    data() {
        return {
            form: {
                course: 'mentalArithmetic',
            },
            courses: [
                'mentalArithmetic',
                'fastReading',
                'onlineSchool',
                'mathMagic',
                'memoryDevelopment',
                'multiplication',
                'readingEn',
            ]
        }
    },
    mounted () {
        this.sendForm();
    },
    watch: {
        '$route.query' (val) {
            if (_.isEmpty(val)) {
                this.form = _.cloneDeep(this.localSearchParams) || {
                    course: null
                };
            }
        },
        'form.course' () {
            this.updateList()
        },
    },
    methods: {
        getCoursesName(course) {
            return this.$i18n.t('common.common_course_' + course)
        },
        sendForm () {
            this.$emit('search', this.form);
        },
        updateList: _.debounce(function() {
            this.sendForm()
        }, 1000)
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        })
    }
}
</script>

<style scoped lang="scss">
.fields {
    display: flex;
    flex-wrap: wrap;
    padding: 0 15px;
}

.fields__element {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    box-sizing: border-box;
    width: 100%;
    @include media($md) {
        flex-direction: row;
        align-items: center;
    }
    @include media($xlg) {
        width: 50%;
    }
}

.fields__element:nth-child(odd) {
    @include media($xlg) {
        padding-right: 40px;
    }
}

.fields__element:last-child {
    margin-bottom: 0;
}

.fields__element--fluid {
    width: auto;
}

.fields__input {
    min-width: 0;
    flex: 1 1 auto;
    margin-bottom: 0;
}

.fields__element--period {
    @include media($xlg) {
        display: flex;
        align-items: center;
        padding: 0;
        width: 100%;
    }
}

.fields__divider {
    text-align: center;
    @include media($md) {
        margin: 0 $space-x-small;
    }
}

.fields__label {
    font-size: 16px;
    line-height: 19px;
    margin-right: 20px;
    margin-bottom: .5rem;
    min-width: 6.5em;
    @include media($md) {
        text-align: right;
    }
    @include media($xlg) {
        margin-bottom: 0;
    }
}

.fields__label--small {
    @include media($xlg) {
        min-width: 5em;
    }
}

.fields__period-buttons-container {
    display: flex;
    flex-wrap: wrap;
    @include media($xlg) {
        margin: 0 20px 0 0;
        flex-wrap: nowrap;
        &:last-child {
            margin-right: 0;
        }
    }
}

.fields__period-buttons-container:before {
    content: '';
    display: none;
    margin-right: 20px;
    min-width: 6.5em;
    @include media($md) {
        display: block;
    }
    @include media($xlg) {
        display: none;
    }
}

.fields__period-button {
    white-space: nowrap;
    text-align: center;
    flex: 1 1 auto;
    color: $hsl-color-blue-56;
    text-decoration: underline;
    &:hover {
        color: $hsl-color-blue-56;
        text-decoration: none;
    }
    margin: 0 20px;
    @include media($xlg) {
        &:last-child {
            margin-right: 0;
        }
    }
}

.fields__element--search-neighbour {
    position: relative;
}

.fields__search {
    position: absolute;
    right: 0;
}
</style>
